const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

// Get all verifications with filters
const getVerifications = async (filters = {}) => {
  const { status, verification_type, search, page = 1, limit = 10, sort_by, sort_order } = filters;
  const token = localStorage.getItem('token');
  
  const queryParams = new URLSearchParams();
  if (status) queryParams.append('status', status);
  if (verification_type) queryParams.append('verification_type', verification_type);
  if (search) queryParams.append('search', search);
  queryParams.append('page', page);
  queryParams.append('limit', limit);
  if (sort_by) queryParams.append('sort_by', sort_by);
  if (sort_order) queryParams.append('sort_order', sort_order);

  const response = await fetch(`${API_URL}/api/v1/admin/verification/verifications?${queryParams.toString()}`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Get verification by ID
const getVerificationById = async (verificationId) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/verifications/${verificationId}`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Update verification status
const updateVerificationStatus = async (verificationId, statusData) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/verifications/${verificationId}/status`, {
    method: 'PUT',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(statusData)
  });
  return response.json();
};

// Get verification documents
const getVerificationDocuments = async (verificationId) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/verifications/${verificationId}/documents`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

// Update document status
const updateDocumentStatus = async (documentId, statusData) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/documents/${documentId}/status`, {
    method: 'PUT',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(statusData)
  });
  return response.json();
};

// Start verification for a user
const startUserVerification = async (userId, verificationType) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/users/${userId}/verification/start`, {
    method: 'POST',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ verification_type: verificationType })
  });
  return response.json();
};

// Upload document for verification
const uploadDocument = async (verificationId, documentData) => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/verifications/${verificationId}/documents`, {
    method: 'POST',
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(documentData)
  });
  return response.json();
};

// Upload file to cloud storage
const uploadFileToCloud = async (file) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch('https://hspbreguarptwwdfhtuj.supabase.co/functions/v1/image-upload', {
    method: 'POST',
    headers: {
      'X-Client': 'ADMIN',
      'Authorization': `Bearer ${token}`
    },
    body: formData
  });

  if (!response.ok) {
    throw new Error('Failed to upload file');
  }

  const uploadData = await response.json();
  return uploadData[0]; // Return the URL
};

// Get verification statistics
const getVerificationStats = async () => {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}/api/v1/admin/verification/verification-stats`, {
    headers: { 
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return response.json();
};

export {
  getVerifications,
  getVerificationById,
  updateVerificationStatus,
  getVerificationDocuments,
  updateDocumentStatus,
  startUserVerification,
  uploadDocument,
  uploadFileToCloud,
  getVerificationStats
}; 